import Link from "antd/es/typography/Link";
import "./MenuOption.scss";
import {
  BankOutlined,
  NotificationOutlined,
  CalendarOutlined,
  ShareAltOutlined,
  UserAddOutlined,
  UsergroupDeleteOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Badge, Grid, Modal, message } from "antd";
import { useEffect, useState } from "react";
import { getConnection } from "../../../controllers/store/actions/connection/connection-actions";
import { useSelector } from "react-redux";
import {
  ImportMessages,
  PageSetting,
  Query,
  RecordStatus,
  RoleType,
} from "../..";
import InstitutionalAdminMenu from "./InstitutionalAdmin";
import KnowledgeConsumerMenu from "./KnowledgeConsumer";
import KnowledgeProviderMenu from "./KnowledgeProvider";
import { find } from "../../../controllers/store/actions/actorTypes/get-actorTypes-actions";
import { find as findCapacities } from "../../../controllers/store/actions/capacitiesType/get-capacitiesTypes-actions";
import ImportModal from "../../components/Forms/Modal/Import/Import";
import { ActionHideModalImport } from "../../../controllers/store/actions/import/import-form-actions";
import store from "../../../controllers/store";
import { ExecuteImport } from "../../../controllers/store/actions/import/execute-import-actions";
import ModalSelectTopics from "../Forms/Modal/Topics/Topics";
import { update } from "../../../controllers/store/actions/users/update-users-actions";
import AdminMenu from "./Admin";
import PublicMenu from "./PublicMenu";
import { setDefault } from "../../../controllers/store/actions/import/get-validation-result-actions";
import { ActionHideModalPreferences } from "../../../controllers/store/actions/preferences/preferences-modal-actions";

interface Props {
  user?: any;
  onClickNotifications: () => void;
}
const { confirm } = Modal;
const dispatch = store.dispatch;
const { useBreakpoint } = Grid;
const MenuOptions = (Props: Props) => {
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const user = useSelector((state: any) => {
    return state.user.user;
  });
  const [modalTopicsVisible, setModalTopicsVisible] = useState<boolean>(
    !user?.me?.preferences
  );
  const showModalImportState = useSelector(
    (state: any) => state.showModalImport
  );
  const [pageCapacity, setpageCapacity] = useState<number>(0);
  const importFromXlstate = useSelector((state: any) => {
    return state.importFromXlsx;
  });

  const modalPreferencesstate = useSelector((state: any) => {
    return state.showModalPreferences;
  });

  const notificationCounter = useSelector((state: any) => {
    return state.connection.data;
  });

  const actorTypesState = useSelector((state: any) => state.actorTypes);
  const capacityTypesState = useSelector((state: any) => state.capacitiesTypes);

  useEffect(() => {
    if (user) {
      dispatch(find(PageSetting.page, PageSetting.limit, {} as Query));
      dispatch(
        findCapacities(PageSetting.page, PageSetting.limit, {} as Query)
      );
      dispatch(
        getConnection(
          {
            meta: "filter_count",
            filter: `&filter[owner_email][_eq]=${user.me.email}&filter[status][_eq]=${RecordStatus.Active}`,
          },
          1,
          15
        )
      );
      if (user.me.preferences || localStorage.getItem("preferences")) {
        dispatch(ActionHideModalPreferences());
      }
    }
  }, []);

  const go = ($event: any, url: string, state: any) => {
    $event.preventDefault();
    navigate(url, { replace: true, state });
  };

  return (
    <>
      {user ? (
        <ModalSelectTopics
          visible={modalPreferencesstate.shoModalPreferences}
          onOk={async (topics) => {
            await dispatch(
              update(user.me.id, {
                preferences: topics,
              })
            );
            message.success(`Preferencias actualizadas correctamente.`);
            localStorage.setItem("preferences", "1");
            dispatch(ActionHideModalPreferences());
          }}
          onCancel={() => {
            dispatch(ActionHideModalPreferences());
          }}
        />
      ) : null}
      <ImportModal
        onAccept={() => {
          confirm({
            okType: "primary",
            okText: "Importar",
            cancelText: "Cancelar",
            title: ImportMessages.Title,
            content: ImportMessages.ImportConfirmMessage,
            onOk: async () => {
              await dispatch(ExecuteImport(importFromXlstate?.upload?.id));
              dispatch(setDefault());
            },
            onCancel() {},
          });
        }}
        onCancel={() => {
          dispatch(setDefault());
          dispatch(ActionHideModalImport());
        }}
        visible={showModalImportState.shoModalImport}
      />
      {screens.lg && (
        <ul className="flex-centered padding-70">
          <li className="menu-option hovered">
            <Link
              onClick={($event) => go($event, "/events-listing", null)}
              href="/events-listing"
              target="_blank"
            >
              <CalendarOutlined className="menu-icon" />
              <span> Eventos</span>
            </Link>
          </li>
          <li className="menu-option hovered">
            <Link
              onClick={($event) => go($event, "/announcements-listing", null)}
              href="/announcements-listing"
              target="_blank"
            >
              <NotificationOutlined className="menu-icon" />
              <span> Convocatorias</span>
            </Link>
          </li>
          <li className="menu-option hovered">
            <Link
              onClick={($event) => go($event, "/entities", null)}
              href="/entities"
              target="_blank"
            >
              <BankOutlined className="menu-icon" />
              <span> Entidades</span>
            </Link>
          </li>
          <li className="menu-option hovered">
            <Link
              onClick={($event) => go($event, "/capacities", null)}
              href="/capacities"
              target="_blank"
            >
              <UsergroupDeleteOutlined className="menu-icon" />
              <span> Capacidades</span>
            </Link>
          </li>
          {user && user.me ? (
            <>
              <li className="menu-option hovered">
                <Link onClick={() => Props.onClickNotifications()}>
                  <ShareAltOutlined className="menu-icon" />
                  <span>
                    {notificationCounter &&
                    notificationCounter?.meta?.filter_count > 0 ? (
                      <Badge
                        overflowCount={99}
                        color="#e15c09"
                        count={notificationCounter.meta?.filter_count || 0}
                      ></Badge>
                    ) : null}
                    Conexiones
                  </span>
                </Link>
              </li>
              <li className="menu-option menu-option-user">
                {user.me?.role?.name === RoleType.InstitutionalAdmin ||
                user.me.role.name === RoleType.Root ? (
                  <InstitutionalAdminMenu
                    user={user}
                    commonsEntities={[]}
                    commonsCapacities={[]}
                  />
                ) : null}
                {user.me?.role?.name === RoleType.Admin ? (
                  <AdminMenu
                    commonsCapacities={capacityTypesState.list}
                    commonsEntities={actorTypesState.list}
                    user={user}
                  />
                ) : null}
                {user.me?.role?.name === RoleType.KnowledgeConsumer ? (
                  <KnowledgeConsumerMenu
                    user={user}
                    commonsCapacities={capacityTypesState.list}
                    commonsEntities={actorTypesState.list}
                  />
                ) : null}
                {user.me?.role?.name === RoleType.KnowledgeProvider ? (
                  <KnowledgeProviderMenu
                    user={user}
                    commonsCapacities={capacityTypesState.list}
                    commonsEntities={actorTypesState.list}
                  />
                ) : null}
              </li>
            </>
          ) : (
            <li className="menu-option hovered">
              <Link
                onClick={($event) => {
                  $event.preventDefault();
                  navigate("/register");
                }}
                href="#"
                target="_blank"
              >
                <UserAddOutlined className="menu-icon" />
                <span> Crear cuenta</span>
              </Link>
            </li>
          )}
        </ul>
      )}
      {screens.xs && (
        <>
          {user ? (
            <ul>
              <li className="menu-option menu-option-user">
                {user?.me?.role?.name === RoleType.InstitutionalAdmin ? (
                  <InstitutionalAdminMenu
                    user={user}
                    commonsEntities={[]}
                    commonsCapacities={[]}
                  />
                ) : null}
                {user?.me?.role?.name === RoleType.Admin ? (
                  <AdminMenu
                    commonsCapacities={capacityTypesState.list}
                    commonsEntities={actorTypesState.list}
                    user={user}
                  />
                ) : null}
                {user?.me?.role?.name === RoleType.KnowledgeConsumer ? (
                  <KnowledgeConsumerMenu
                    user={user}
                    commonsCapacities={capacityTypesState.list}
                    commonsEntities={actorTypesState.list}
                  />
                ) : null}
                {user?.me?.role?.name === RoleType.KnowledgeProvider ? (
                  <KnowledgeProviderMenu
                    user={user}
                    commonsCapacities={capacityTypesState.list}
                    commonsEntities={actorTypesState.list}
                  />
                ) : null}
              </li>
            </ul>
          ) : (
            <PublicMenu />
          )}
        </>
      )}
    </>
  );
};

export default MenuOptions;
